/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseListReferentialCategory } from '../models/api-response-list-referential-category';
import { ApiResponsePagedResultReferentialCategory } from '../models/api-response-paged-result-referential-category';
import { ApiResponseReferentialCategory } from '../models/api-response-referential-category';
import { createReferentialCategory } from '../fn/referential-category-api/create-referential-category';
import { CreateReferentialCategory$Params } from '../fn/referential-category-api/create-referential-category';
import { deleteReferentialCategory } from '../fn/referential-category-api/delete-referential-category';
import { DeleteReferentialCategory$Params } from '../fn/referential-category-api/delete-referential-category';
import { getReferentialCategoryByRef } from '../fn/referential-category-api/get-referential-category-by-ref';
import { GetReferentialCategoryByRef$Params } from '../fn/referential-category-api/get-referential-category-by-ref';
import { listReferentialCategory } from '../fn/referential-category-api/list-referential-category';
import { ListReferentialCategory$Params } from '../fn/referential-category-api/list-referential-category';
import { patchArchiveStatusCategory } from '../fn/referential-category-api/patch-archive-status-category';
import { PatchArchiveStatusCategory$Params } from '../fn/referential-category-api/patch-archive-status-category';
import { searchReferentialCatgory } from '../fn/referential-category-api/search-referential-catgory';
import { SearchReferentialCatgory$Params } from '../fn/referential-category-api/search-referential-catgory';
import { updateReferentialCategory } from '../fn/referential-category-api/update-referential-category';
import { UpdateReferentialCategory$Params } from '../fn/referential-category-api/update-referential-category';

@Injectable({ providedIn: 'root' })
export class ReferentialCategoryApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getReferentialCategoryByRef()` */
  static readonly GetReferentialCategoryByRefPath = '/v1/api/ui/referential/category/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getReferentialCategoryByRef()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReferentialCategoryByRef$Response(params: GetReferentialCategoryByRef$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseReferentialCategory>> {
    return getReferentialCategoryByRef(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getReferentialCategoryByRef$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReferentialCategoryByRef(params: GetReferentialCategoryByRef$Params, context?: HttpContext): Observable<ApiResponseReferentialCategory> {
    return this.getReferentialCategoryByRef$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseReferentialCategory>): ApiResponseReferentialCategory => r.body)
    );
  }

  /** Path part for operation `updateReferentialCategory()` */
  static readonly UpdateReferentialCategoryPath = '/v1/api/ui/referential/category/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateReferentialCategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateReferentialCategory$Response(params: UpdateReferentialCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseReferentialCategory>> {
    return updateReferentialCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateReferentialCategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateReferentialCategory(params: UpdateReferentialCategory$Params, context?: HttpContext): Observable<ApiResponseReferentialCategory> {
    return this.updateReferentialCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseReferentialCategory>): ApiResponseReferentialCategory => r.body)
    );
  }

  /** Path part for operation `deleteReferentialCategory()` */
  static readonly DeleteReferentialCategoryPath = '/v1/api/ui/referential/category/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteReferentialCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteReferentialCategory$Response(params: DeleteReferentialCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteReferentialCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteReferentialCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteReferentialCategory(params: DeleteReferentialCategory$Params, context?: HttpContext): Observable<void> {
    return this.deleteReferentialCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createReferentialCategory()` */
  static readonly CreateReferentialCategoryPath = '/v1/api/ui/referential/category';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createReferentialCategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createReferentialCategory$Response(params: CreateReferentialCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseReferentialCategory>> {
    return createReferentialCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createReferentialCategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createReferentialCategory(params: CreateReferentialCategory$Params, context?: HttpContext): Observable<ApiResponseReferentialCategory> {
    return this.createReferentialCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseReferentialCategory>): ApiResponseReferentialCategory => r.body)
    );
  }

  /** Path part for operation `searchReferentialCatgory()` */
  static readonly SearchReferentialCatgoryPath = '/v1/api/ui/referential/category/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchReferentialCatgory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchReferentialCatgory$Response(params: SearchReferentialCatgory$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultReferentialCategory>> {
    return searchReferentialCatgory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchReferentialCatgory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchReferentialCatgory(params: SearchReferentialCatgory$Params, context?: HttpContext): Observable<ApiResponsePagedResultReferentialCategory> {
    return this.searchReferentialCatgory$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultReferentialCategory>): ApiResponsePagedResultReferentialCategory => r.body)
    );
  }

  /** Path part for operation `patchArchiveStatusCategory()` */
  static readonly PatchArchiveStatusCategoryPath = '/v1/api/ui/referential/category/archive/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchArchiveStatusCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchArchiveStatusCategory$Response(params: PatchArchiveStatusCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return patchArchiveStatusCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchArchiveStatusCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchArchiveStatusCategory(params: PatchArchiveStatusCategory$Params, context?: HttpContext): Observable<void> {
    return this.patchArchiveStatusCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listReferentialCategory()` */
  static readonly ListReferentialCategoryPath = '/v1/api/ui/referential/category/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listReferentialCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  listReferentialCategory$Response(params: ListReferentialCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListReferentialCategory>> {
    return listReferentialCategory(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listReferentialCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listReferentialCategory(params: ListReferentialCategory$Params, context?: HttpContext): Observable<ApiResponseListReferentialCategory> {
    return this.listReferentialCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListReferentialCategory>): ApiResponseListReferentialCategory => r.body)
    );
  }

}
